import { render, staticRenderFns } from "./AppErrorDialog.vue?vue&type=template&id=36471b30"
import script from "./AppErrorDialog.vue?vue&type=script&lang=js"
export * from "./AppErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports